import React from "react";
import { Link } from "react-router-dom";
import { FaTiktok, FaYoutube } from "react-icons/fa";
import {
	Flex,
	SectionContainer,
	SectionContent,
} from "../../styles/global.syles";
import footerlogo from "../../images/logo-footer.png";
import { DividerAndCopy, FooterContent } from "./Footer.styles";

const Footer = () => {
	return (
		<SectionContainer bg='#f1fbf2' pb='0'>
			<FooterContent>
				<Flex justify='space-between' gap='20px' className='footer-flex'>
					{/* logo  */}
					<div className='logo'>
						<img src={footerlogo} alt='logo' width='172' />
					</div>
					{/* links  */}
					<Flex justify='flex-end' gap='30px' className='info-flex'>
						<div className='info'>
							<div className='info-title'>Send Email</div>
							<div className='info-des'>
								<a href="mailto:beyondlottotv@gmail.com">beyondlottotv@gmail.com</a>
							</div>
						</div>
						<div className='info'>
							<div className='info-title'>Hotline</div>
							<div className='info-des'>
								<a href="tel:6823860871">(682) 386-0871</a>
							</div>
						</div>
						<div className='info'>
							<div className='info-title'>Texas</div>
							<div className='info-des'>
								<a href="tel:8323883526">(832) 388-3526</a>
							</div>
						</div>
						<div className='info'>
							<div className='info-title'>Houston</div>
							<div className='info-des'>
								<a href="tel:3464981097">(346) 498-1097</a>
							</div>
						</div>
						<div className="info">
							<div className="info-title">
								<Link to="/privacypolicy" className="text-dark text-decoration-none">
									Privacy Policy
								</Link>
							</div>
							<div className="info-des">
								<Link to="/termsandconditions" className="text-dark text-decoration-none">
									Terms &amp; Conditions
								</Link>
							</div>
						</div>
						<div className="info">
							<div className="info-title">Follow Us</div>
							<div className="info-des" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
								<a
									href="https://www.tiktok.com/@beyondlotto7?_r=1&_t=ZP-9AKXK2mfBvj"
									target="_blank"
									rel="noopener noreferrer"
									className="footer-social-icon tiktok"
									title="Follow on TikTok"
									aria-label="TikTok"
								>
									<FaTiktok />
								</a>
								<a
									href="https://youtube.com/@beyondlottery?si=EXAbnJXS3tD2N3o3"
									target="_blank"
									rel="noopener noreferrer"
									className="footer-social-icon youtube"
									title="Subscribe on YouTube"
									aria-label="YouTube"
								>
									<FaYoutube />
								</a>
							</div>
						</div>
					</Flex>
				</Flex>
			</FooterContent>
			<DividerAndCopy>
				<div className='divider'></div>
				<div className='copyright'>&copy; 2024 BeyondLottery. All rights reserved.</div>
			</DividerAndCopy>
		</SectionContainer>
	);
};

export default Footer;
